import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Canonical-host redirect: if the user lands on the apex jesusjustus.us,
// send them to www.jesusjustus.us so login cookies are scoped consistently.
// Cloudflare 308-redirects /api/* from apex to www, which breaks the
// httpOnly login cookie if the frontend stays on the apex host. We avoid
// that by keeping the whole app on www.
(function ensureCanonicalHost() {
  if (typeof window === "undefined") return;
  if (window.location.hostname === "jesusjustus.us") {
    const target =
      "https://www.jesusjustus.us" +
      window.location.pathname +
      window.location.search +
      window.location.hash;
    window.location.replace(target);
  }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the service worker for PWA / offline support.
// Skips when running on localhost in dev to avoid stale-cache headaches.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
    if (isLocalhost) return;
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch(() => {});
  });
}
